module.exports = __webpack_public_path__ + "static/media/commercial.67484738.jpeg";